import {IonicModule} from "@ionic/angular";
import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {SingleMessageComponent} from "./single-message.component";
import {DatetimeLabelModule} from '../../../../core/component/date/datetime-label/datetime-label.module';
import {ButtonModule} from '../../../../core/component/button/button.module';
import {UserAvatarModule} from "../../../../account/modules/user/api/component/user-avatar/user-avatar.module";
import {
    UserSummaryFieldModule
} from "../../../../account/modules/user/api/component/user-summary-field/user-summary-field.module";
import {LoadingModule} from "../../../../../components/common/loading/loading.module";
import {AppErrorComponent} from "../../../../../pages/authentication/error/error.component";
import {ErrorTextModule} from "../../../../core/component/error-text/error-text.module";
import {ActionButtonModule} from "../../../../core/component/action-button/action-button.module";
import {AudioPlayerComponent} from "../../../../common/audio/player/api/component/audio-player/audio-player.component";
import {
    DocumentDownloadModule
} from "../../../../document/common/api/component/document-download/document-download.module";
import {
    DocumentDownloadLinkComponent
} from "../../../../document/common/api/component/document-download-link/document-download-link.component";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        DatetimeLabelModule,
        ButtonModule,
        UserAvatarModule,
        UserSummaryFieldModule,
        LoadingModule,
        AppErrorComponent,
        ErrorTextModule,
        ActionButtonModule,
        DocumentDownloadModule,
        DocumentDownloadLinkComponent,
    ],
    declarations: [
        SingleMessageComponent,
    ],
    exports: [
        SingleMessageComponent,
    ],
})
export class SingleMessageModule{}